import Spare from "assets/unityMenu/Spare.png";
import SpareSelected from "assets/unityMenu/SpareSelected.png";
import Dense from "assets/unityMenu/Dense.png";
import DenseSelected from "assets/unityMenu/DenseSelected.png";
import DGS from "assets/unityMenu/3DGS.png";
import DGSSelected from "assets/unityMenu/3DGS_Selected.png";
import ModelsIcon from "assets/unityMenu/3D_icon.png";
import ModelsIconSelected from "assets/unityMenu/3D_iconOn.png";
import notesIcon from "assets/unityMenu/notes.png";
import CameraOn from "assets/unityMenu/CameraOn.png";
import IdleCameraOn from "assets/unityMenu/IdleCameraOn.png";
import IdleCameraOff from "assets/unityMenu/IdleCameraOff.png";
import WidgetSwitchOn from "assets/unityMenu/WidgetSwitchOn.png";
import WidgetSwitch from "assets/unityMenu/WidgetSwitch.png";
import DroneIcon from "assets/unityMenu/drone_icon.png";
import ManIcon from "assets/unityMenu/man_icon.png";
import MapIcon from "assets/unityMenu/map_icon.png";
import { ReactComponent as Ruler } from "assets/unityMenu/ruler.svg";
import { useUnityActions } from "hooks/unityActions";
import { FaCog } from "react-icons/fa";
import { useEffect, useState, useContext } from "react";
import { useMinifiedMenu } from "hooks/useMinifiedMenu";
import classNames from "utilities/ClassNames";
import { MdCameraAlt, MdAutorenew } from "react-icons/md";

const UnityIconButton = ({ icon, onBtnClick }: { icon: React.ReactNode, onBtnClick: any }) => {
  return (
    <button className="w-10 h-10 p-1" onClick={onBtnClick}>
      {typeof icon === "string" ? (
        <img src={icon} alt="icon" className="w-full h-full" />
      ) : (
        icon
      )}
    </button>
  );
};

const UnityActionsWindow = () => {

  const {
    addItemToPosition,
    removeMinifiedTab
  } = useMinifiedMenu();

  const {
    modelDensity, setModelDensity,
    show3DModel, setShow3DModel,
    editingMode, setEditingMode,
    cameraMode, setCameraMode,
    idleCameraMode, setIdleCameraMode,
    widgetSwitch, setWidgetSwitch,
    viewMode, setViewMode,
    measurementMode, setMeasurementMode,
    cameraReset, setCameraReset
  } = useUnityActions();

  useEffect(() => {
    if (cameraReset) {
      const message = JSON.stringify({
        object: "__ProjectsManager__",
        type: "ProjectsManager",
        method: "ResetCamera",
        arguments: []
      });
      window.vuplex.postMessage(message);
      setCameraReset(false);
    }
  }, [cameraReset]);

  const sendStateToUnity = (method: string, readyArguments: any) => {
    if (window.vuplex) {
      window.vuplex.postMessage(JSON.stringify({
        object: 'ReactUIManager',
        type: 'ReactUIManager',
        method: method,
        arguments: [JSON.stringify(readyArguments)]
      }));
    }
  };

  function addMessageListener() {
    window.vuplex.addEventListener("message", async function (event: { data: any }) {
      const tjson = event.data;
      const parsedInfo = JSON.parse(tjson);
      if (parsedInfo.methodName === 'GetToggleGroup') {
        const toggleGroup = JSON.parse(parsedInfo.message);
        if (toggleGroup.Keyword === 'CameraMode') {
          setViewMode(toggleGroup.value);
        }
      }
      if (parsedInfo.methodName === 'GetToggle') {
        const toggleItem = JSON.parse(parsedInfo.message);
        if (toggleItem.Keyword === 'EditingMode') {
          setEditingMode(toggleItem.value);
          setViewMode(0);
        }
      }
    });
  }

  useEffect(() => {
    if (window.vuplex) {
      setTimeout(addMessageListener, 1000);
    } else {
      window.addEventListener('vuplexready', addMessageListener);
    }
    return () => {
      window.removeEventListener('vuplexready', addMessageListener);
    };
  }, []);

  useEffect(() => {
    sendStateToUnity('SetToggleGroup', ['PointCloudMode', modelDensity]);
  }, [modelDensity]);

  useEffect(() => {
    sendStateToUnity('SetToggle', ['Show3DModel', show3DModel]);
  }, [show3DModel]);

  useEffect(() => {
    sendStateToUnity('SetToggle', ['EditingMode', editingMode]);
  }, [editingMode]);

  useEffect(() => {
    sendStateToUnity('SetToggle', ['ShowPhotoIcons', cameraMode]);
  }, [cameraMode]);

  useEffect(() => {
    sendStateToUnity('SetToggle', ['FlyByMode', idleCameraMode]);
  }, [idleCameraMode]);

  useEffect(() => {
    sendStateToUnity('SetToggle', ['ShowWidgets', widgetSwitch]);
  }, [widgetSwitch]);

  useEffect(() => {
    sendStateToUnity('SetToggleGroup', ['CameraMode', viewMode]);
  }, [viewMode]);

  const handleViewModeClick = () => {
    if (viewMode === 2) {
      setViewMode(0);
    } else {
      setViewMode((prev) => prev + 1);
    }
  };

  const cameraModeIcons = [
    ManIcon,
    DroneIcon,
    MapIcon
  ];

  const onRullerClick = () => {
    if (measurementMode) {
      removeMinifiedTab('measurements', 'right');
    }
    else {
      addItemToPosition('bottomRight', { type: 'measurements', data: null });
    }
    setMeasurementMode((prev) => !prev);
  };

  return (
    <div className="bg-dark/70 rounded-md flex gap-2 pr-1">
      <div className="bg-dark/40 rounded-md px-1">
        <UnityIconButton icon={modelDensity === 0 ? SpareSelected : Spare} onBtnClick={() => setModelDensity(0)} />
        <UnityIconButton icon={modelDensity === 1 ? DenseSelected : Dense} onBtnClick={() => setModelDensity(1)} />
        <UnityIconButton icon={modelDensity === 2 ? DGSSelected : DGS} onBtnClick={() => setModelDensity(2)} />
      </div>
      <UnityIconButton icon={show3DModel ? ModelsIconSelected : ModelsIcon} onBtnClick={() => setShow3DModel((prev) => !prev)} />
      <UnityIconButton icon={notesIcon} onBtnClick={() => sendStateToUnity('SetButton', 'AddNote')} />
      <UnityIconButton icon={<FaCog size={24} className={editingMode ? "text-blue" : "text-white"} />} onBtnClick={() => setEditingMode((prev) => !prev)} />
      <div className={cameraMode ? "" : "crossedCamera"}>
        <UnityIconButton icon={CameraOn} onBtnClick={() => setCameraMode((prev) => !prev)} />
      </div>
      <UnityIconButton icon={idleCameraMode ? IdleCameraOff : IdleCameraOn} onBtnClick={() => setIdleCameraMode((prev) => !prev)} />
      <UnityIconButton icon={widgetSwitch ? WidgetSwitchOn : WidgetSwitch} onBtnClick={() => setWidgetSwitch((prev) => !prev)} />
      <UnityIconButton icon={cameraModeIcons[viewMode]} onBtnClick={handleViewModeClick} />
      <button className="relative w-10 h-10" onClick={() => setCameraReset(true)}>
        <MdAutorenew
          className={classNames(
            "absolute inset-0 m-auto text-gray-400 transition-transform duration-1000 ease-out",
            cameraReset ? "rotate-[360deg]" : "rotate-0"
          )}
          size={38}
        />
        <MdCameraAlt className="absolute inset-0 m-auto text-white" size={16} />
      </button>
      <UnityIconButton icon={<Ruler className={classNames(measurementMode ? "text-[#53c8a1]" : "text-white", "h-full w-full")} />} onBtnClick={() => onRullerClick()} />
    </div>
  );
};

export default UnityActionsWindow;